import React, { useEffect } from 'react'
import { Box, Divider, Grid, Paper, Typography } from '@material-ui/core'

import {
  Impact,
  LargeScale,
  SignificantlyAffect,
  SpecificCriteria,
  Stepper,
} from './components'

import useIncidentManegement from 'hooks/useIncidentManegement'
import useIncidentHighRisk from 'hooks/useIncidentHighRisk'
import incidentHighRiskSteps from 'helpers/incidents/incidentHighRiskSteps'

import constants from 'constants/index'

const HighRiskStep = ({ refresh }) => {
  const { handleBack, wantsToReturnStep, resetReturnStep, isDpo } =
    useIncidentManegement()

  const { activeHighRiskStep, handleHighRiskBack } = useIncidentHighRisk()

  const { HIGH_RISK_STEPS } = constants.incidentHighRisk

  const steps = incidentHighRiskSteps(isDpo)
  const step = steps[activeHighRiskStep]

  const stepComponents = {
    large_scale: <LargeScale refresh={refresh} />,
    specific_criteria: <SpecificCriteria refresh={refresh} />,
    significantly_affect: <SignificantlyAffect refresh={refresh} />,
    impact: <Impact />,
  }

  const visibleSteps = isDpo ? steps : steps.slice(0, 2)
  const totalVisibleSteps = visibleSteps.length

  useEffect(() => {
    if (wantsToReturnStep) {
      if (activeHighRiskStep > 0) {
        handleHighRiskBack()
      } else {
        handleBack()
      }
    }
    resetReturnStep()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wantsToReturnStep])

  return (
    <Grid container>
      <Grid item xl={9} lg={9} md={8} xs={12}>
        <Paper id={constants.incidents.INCIDENT_MAIN_DRIVER_STEP_5}>
          <Box
            display="flex"
            width="100%"
            justifyContent="space-between"
            alignItems="center"
            p={2}
            fontWeight={500}
          >
            <Typography variant="subtitle1">
              <Box fontWeight="bold">
                {HIGH_RISK_STEPS[activeHighRiskStep]?.title}
              </Box>
            </Typography>
            <Typography variant="subtitle1">
              Etapa {activeHighRiskStep + 1} de {totalVisibleSteps}
            </Typography>
          </Box>
          <Divider />
          <Grid container>
            <Grid item xs={12}>
              <Box mt={3} />

              {stepComponents[step]}
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item xl={3} lg={3} md={4} xs={12}>
        <Stepper activeStep={activeHighRiskStep} steps={steps} isDpo={isDpo} />
      </Grid>
    </Grid>
  )
}

export default HighRiskStep
